import * as React from 'react';
import { styles } from './styles';
import { cx } from 'emotion';
import { variables } from '../../variables';
import { ColumnWidth, ColumnGap, InjectedColumnProps } from '../../types';

export interface ColumnProps {
  className?: string;
  // deviceWidth: DeviceWidth;
  columnGap?: ColumnGap;

  // TODO: Might be worthwhile to add this as a passed proped via columns, to enforce proper usage
  // __isNestedUnderColumns: boolean;

  mobileOffset?: ColumnWidth;
  mobile?: ColumnWidth;

  tablet?: ColumnWidth;
  tabletOffset?: ColumnWidth;

  desktop?: ColumnWidth;
  desktopOffset?: ColumnWidth;
  widescreen?: ColumnWidth;
  widescreenOffset?: ColumnWidth;
}

class Column extends React.Component<ColumnProps & InjectedColumnProps> {
  render() {
    const className = cx(styles.container(this.props), variables.COLUMN_CLASS_NAME, this.props.className);
    return <div className={className}>{this.props.children}</div>;
  }
}

export { Column };
